module.exports = __webpack_public_path__ + "media/freeze.2d9d5af4.mp4";